import { FormIntegrationDetailPanes } from 'cio/components/forms/custom/integration-details';
import { TransformsList } from 'cio/utils/analytics/transforms';
import { FormType } from 'cio/utils/forms';

const FORM_TYPE_LABEL_FACEBOOK = 'Facebook';
const FORM_TYPE_LABEL_CUSTOM_SCANNED = 'Custom - Scanned';
const FORM_TYPE_LABEL_CUSTOM_API = 'Custom - API';
const FORM_TYPE_LABEL_CUSTOM_HTML_ACTION = 'Custom - HTML Action';
const FORM_TYPE_LABEL_TYPEFORM = 'Typeform';

const Transforms: TransformsList = {
  source(data: { from: string }) {
    return {
      Source: data.from,
    };
  },

  listViewedOrFiltered(data: { filteredTo: 'Active' | 'Archived' | 'All' }) {
    return {
      'Filtered To': data.filteredTo,
    };
  },

  codeViewed(data: { type: FormIntegrationDetailPanes }) {
    let codeTypeLabels: Record<FormIntegrationDetailPanes, string> = {
      [FormIntegrationDetailPanes.FormsEndpoint]: 'Forms Endpoint',
      [FormIntegrationDetailPanes.JavaScriptSnippet]: 'JS Snippet',
      [FormIntegrationDetailPanes.HTMLAction]: 'HTML Action',
      [FormIntegrationDetailPanes.Typeform]: 'Typeform',
      [FormIntegrationDetailPanes.Jotform]: 'Jotform',
    };

    return {
      'Code Displayed': codeTypeLabels[data.type],
    };
  },

  codeCopied(data: {
    type: 'Forms Endpoint URL' | 'Forms Endpoint Code' | 'JS Snippet' | 'HTML Action';
    language?: 'cURL';
  }) {
    return {
      'Content Copied': data.type,
      Language: data.language,
    };
  },

  formAction(data: {
    action: 'Managing' | 'Connecting' | 'Disconnecting';
    formType: FormType;
    environmentId: string;
    api: boolean;
    scanned: boolean;
    formId?: string;
  }) {
    let formID = data.formId ? `${data.environmentId}_${data.formId}` : undefined;

    let formTypeLabel: string;
    if (data.formType === FormType.FacebookLeadAds) {
      formTypeLabel = FORM_TYPE_LABEL_FACEBOOK;
    } else if (data.formType === FormType.Typeform) {
      formTypeLabel = FORM_TYPE_LABEL_TYPEFORM;
    } else {
      if (data.api) {
        formTypeLabel = FORM_TYPE_LABEL_CUSTOM_API;
      } else if (data.scanned) {
        formTypeLabel = FORM_TYPE_LABEL_CUSTOM_SCANNED;
      } else {
        formTypeLabel = FORM_TYPE_LABEL_CUSTOM_HTML_ACTION;
      }
    }

    return {
      'Form Action': data.action,
      'Form Type': formTypeLabel,
      'Form ID': formID,
    };
  },

  formBuilderClicked(data: { integrationName: string }) {
    return {
      'Integration Name': data.integrationName,
    };
  },

  setupFindFormTabViewed(data: { from: string; rescanning?: boolean }) {
    return {
      Source: data.from,
      'Re-scan': Boolean(data.rescanning),
    };
  },

  setupSelectFormTabViewed(data: { from: string; formsCount: number; formFieldsCounts: number[] }) {
    return {
      Source: data.from,
      'Forms Detected': data.formsCount,
      'Number of Form Fields': data.formFieldsCounts,
    };
  },
};

export default Transforms;
